import { call, fork, put, takeEvery } from "typed-redux-saga";
import { getAppServerClient } from "@advosys/component-app-server-client-js";
import { AboutDialogActionTypes, actions } from "./about-dialog-store";
function* getAppServerVersion() {
    const apiResult = yield* call(getAppServerClient().common.appServerV2.getVersionAsync);
    if (apiResult.ok) {
        yield* put(actions.getAppServerVersionSuccess(apiResult.data));
    }
    else {
        yield* put(actions.getAppServerVersionFail(apiResult.error));
    }
}
function* watchGetAppServerVersionRequest() {
    yield* takeEvery(AboutDialogActionTypes.GetAppServerVersionRequest, getAppServerVersion);
}
export const aboutDialogSagaInit = () => [fork(watchGetAppServerVersionRequest)];
